import { OffshoreReportsVm, ReducedOffshoreReport } from '@navstation-portal/reporting/data-model/offshore-reports';

export function buildOffshoreReportsVm(reports: ReducedOffshoreReport[]): OffshoreReportsVm {
  const sorted = [...reports].sort((a, b) => a.reportNumber - b.reportNumber);
  const latestReport = sorted.length > 0 ? sorted[sorted.length - 1] : undefined;
  const incompleteReportId = latestReport && latestReport.status !== 'complete' ? String(latestReport.id) : null;

  return {
    nextReportNumber: reports.length ? reports.length + 1 : 1,
    incompleteReportId,
  };
}
